import React from 'react';
import PropTypes from 'prop-types';

const SvgComponent = ({ fill, ...props }) => (
  <svg viewBox="0 0 24 24" { ...props }>
    <path
      d="M23.66 9.03L14.97.34c-.23-.23-.53-.34-.82-.34-.42 0-.83.22-1.04.63l-2.37 3.85 1.78 1.78-2.32 2.33c-1.1-.44-2.26-.65-3.42-.65-2.37 0-4.74.9-6.56 2.71l5.63 5.63L0 23.2l.8.8 7.37-5.39 5.17 5.17c2.7-2.7 3.38-6.64 2.07-9.97l2.32-2.32 1.78 1.78 3.85-2.37c.71-.37.86-1.31.3-1.87zm-3.85 1.7l-.66-.66-1.41-1.41-1.41 1.41L14 12.39l-.93.93.48 1.22c.81 2.06.64 4.34-.4 6.21l-9.9-9.9a7.303 7.303 0 016.21-.4l1.22.48.93-.93 2.32-2.32 1.41-1.41-1.41-1.41-.66-.66 1.04-1.69L21.5 9.7l-1.69 1.03z"
      fill={ fill }
    />
  </svg>
);

SvgComponent.propTypes = {
  fill: PropTypes.string.isRequired
};

export default SvgComponent;
